module.exports = "<button class=\"btn btn-default btn-full-width mt-10 mb-15\"\n        type=\"button\"\n        [disabled]=\"isDisabled\"\n        (click)=\"onBtnClick()\"\n>Cancel</button>\n"


//////////////////
// WEBPACK FOOTER
// ./mobile/src/components/buttons/cancel-btn/cancel-btn.html
// module id = ./mobile/src/components/buttons/cancel-btn/cancel-btn.html
// module chunks = 0